// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-menu[data-v-21bd11ab]{display:flex}.header-menu>*[data-v-21bd11ab]{margin-left:20px}.header-menu[data-v-21bd11ab]>:first-child{margin-left:0}@media(max-width:1023px){.header-menu[data-v-21bd11ab]{flex-direction:column}.header-menu>*[data-v-21bd11ab]{margin-top:15px;margin-left:0}.header-menu[data-v-21bd11ab]>:first-child{margin-top:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
